import React from 'react';
import PropTypes from 'prop-types';

import { withSubscription } from '@spotahome/soyuz-mediator';

import '@spotahome/ui-library/lib/components/Button.css';
import '@spotahome/ui-library/lib/components/CloseButton.css';

import { OPEN_ALERT } from '../channels';

import './login/LoginModalStyles';

import withModalHandle from './withModalHandle';
import LoginModal from './login/LoginModal';

const modalEvents = {
  open: {
    eventCategory: 'signup/login modal',
    eventAction: 'Alerts',
    eventLabel: 'open'
  },
  close: {
    eventCategory: 'signup/login modal',
    eventAction: 'Alerts',
    eventLabel: 'close'
  }
};

const LoginModalSubscribedToAlerts = withSubscription({
  channelName: OPEN_ALERT
})(props => (
  <LoginModal
    initialAction="signup"
    isOpen={props.isOpen}
    onClose={props.onClose}
  />
));

LoginModalSubscribedToAlerts.propTypes = {
  onEvent: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

const AlertsLoginModal = withModalHandle(modalEvents)(props => (
  <LoginModalSubscribedToAlerts
    isOpen={props.isModalOpen}
    onClose={props.handleModalClose}
    onEvent={props.handleModalOpen}
  />
));

AlertsLoginModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  handleModalOpen: PropTypes.func.isRequired
};

export default AlertsLoginModal;
